export default __webpack_public_path__ + "static/media/mindful.9c2293fa.png";